import { Injectable } from '@angular/core';
import { AppState } from '@core/constants/app-state.enum';
import { getAngularJSService } from '../ng-upgrade.utils';

interface LegacyStateService {
  go(to: string, params?: Record<string, unknown>): unknown;
}

interface LegacyLocationService {
  search(): Record<string, string | undefined>;
}

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private stateService: LegacyStateService | null = null;
  private locationService: LegacyLocationService | null = null;

  private get $state(): LegacyStateService {
    if (this.stateService) {
      return this.stateService;
    }
    const svc = getAngularJSService<LegacyStateService>('$state');
    if (!svc) {
      throw new Error('$state AngularJS não disponível. AngularJS pode não ter sido bootstrapped.');
    }
    this.stateService = svc;
    return this.stateService;
  }

  private get $location(): LegacyLocationService {
    if (this.locationService) {
      return this.locationService;
    }
    const svc = getAngularJSService<LegacyLocationService>('$location');
    if (!svc) {
      throw new Error(
        '$location AngularJS não disponível. AngularJS pode não ter sido bootstrapped.'
      );
    }
    this.locationService = svc;
    return this.locationService;
  }

  goToState(state: AppState, params?: Record<string, unknown>): void {
    // WRAPPER — substituir por Router.navigate() na Fase de Saída
    this.$state.go(state, params);
  }

  getQueryParam(name: string): string | null {
    // WRAPPER — substituir por ActivatedRoute na Fase de Saída
    const value = this.$location.search()[name];
    return typeof value === 'string' && value.length > 0 ? value : null;
  }

  redirectToExternal(url: string): void {
    window.location.assign(url);
  }
}
